<template>
  <div class="detail-box">
    <!--<span class="title">{{title}}</span>-->

    <div class="content" v-html="htmlData">
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: [String, Number]
  },
  data () {
    return {
      title: '',
      htmlData: '' // 富文本内容
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getDetailById()
    },
    async getDetailById () {
      const config = {
        10: this.$https.getPtjs,
        11: this.$https.getPtzc,
        12: this.$https.getZzjg
      }
      const res = await config[this.id]()
      this.htmlData = res.data.data
    }
  }
}
</script>

<style scoped lang="less">
  .detail-box{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 20px;

    .title{
      font-family: PingFang;
      font-weight: bold;
      font-size: 20px;
      color: #0067D1;
      line-height: 22px;
      width: 100%;
      text-align: center;
      margin-bottom: 70px;
    }

    .content{
      width: 100%;
      overflow-x: auto;
      word-break: break-word;
    }
  }
</style>
